import { keyBy } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../index';

export const getBundleByGuid = createSelector(
  (state: RootState) => state.productionModels.orderedBundlesByScheduleLineGroupGuid,

  (orderedBundlesByScheduleLineGroupGuid) =>
    keyBy(
      Object.values(orderedBundlesByScheduleLineGroupGuid).flatMap((bundles) => bundles),
      (bundle) => bundle.guid,
    ),
);
